import { render, staticRenderFns } from "./querySqlContent.vue?vue&type=template&id=524b1061&scoped=true&"
import script from "./querySqlContent.vue?vue&type=script&lang=js&"
export * from "./querySqlContent.vue?vue&type=script&lang=js&"
import style0 from "./querySqlContent.vue?vue&type=style&index=0&id=524b1061&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524b1061",
  null
  
)

export default component.exports